const Status = {
  Empty: 'Empty',
  Rejected: 'Rejected',
  Pending: 'Pending',
  Fullfilled: 'Fullfilled'
};
export default Status;
